import dayjs from "dayjs";
import * as S from "./PointHistoryItem.style";
import { Point } from "@/common/types/point";

interface PointHistoryItemProps {
  data: Point;
}

export const PointHistoryItem = ({ data }: PointHistoryItemProps) => {
  return (
    <>
      {data?.point > 0 ? (
        <S.PointHistoryItem>
          <S.PointHistroyTit>
            <span>
              {data?.createdAt
                ? dayjs(data.createdAt).format("YYYY-MM-DD HH:mm:ss")
                : ""}
            </span>
            {data?.reason}
          </S.PointHistroyTit>

          <S.PointBox $type={data.type}>
            {data?.type === "ADD" ? "+" : "-"}
            {data?.point} P
          </S.PointBox>
        </S.PointHistoryItem>
      ) : (
        <></>
      )}
    </>
  );
};
